export default [
  {
    value: 'Win',
    opt: 'win'
  },
  {
    value: 'Achievement',
    opt: 'achievement'
  },
  {
    value: 'Sport Update',
    opt: 'sportUpdate'
  }
];
